import axiosInstance from "../axiosInterceptor";

export async function getMenu() {
  try{
    const response = await axiosInstance.get(`menu/getmenus`);
  const data = response?.data;
  return data;
  }catch(error){
     return {isSuccess:false,message:error.message || "Something went wrong! Please try again later.",data:[]}
  }
}
